import { LiquidProductVariant } from '@/features/product/types/LiquidProduct'
import { create } from 'zustand'

export const useProductPageStore = create<{
  selectedVariant: LiquidProductVariant | undefined
  isDetailsOpen: boolean
  setSelectedVariant: (variant: LiquidProductVariant) => void
  setIsDetailsOpen: (isOpen: boolean) => void
}>((set) => ({
  selectedVariant: undefined,
  isDetailsOpen: false,
  setSelectedVariant: (variant: LiquidProductVariant) =>
    set({ selectedVariant: variant }),
  setIsDetailsOpen: (isOpen: boolean) => set({ isDetailsOpen: isOpen }),
}))
